import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, debounceTime, delay, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CheckEmailInterface } from '../interfaces/check-email.interface';

@Injectable({
  providedIn: 'root'
})
export class CheckEmailValidatorsService implements AsyncValidator {

  private http = inject(HttpClient);

  emailTakenError: string | null = null;
  private baseUrl: string = environment.baseUrlAuth;

  validate(control: AbstractControl<CheckEmailInterface>): Observable<ValidationErrors | null> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });

    const email: CheckEmailInterface = control.value;
    return this.http.get<CheckEmailInterface>(`${this.baseUrl}/api/auth/check-email?email=${email}`, {headers})
      .pipe(
        delay(2000),
        // tap((res) => console.log("Respuesta",res)),
        map((resp: CheckEmailInterface) => {
          // console.log('responsDb',resp)
          if ( resp?.email?.userExits === true) {
            this.emailTakenError = `El email: ${email} ya esta en uso`;
            return  {
              emailTaken: true
            };
          } else {
            this.emailTakenError = null
            return null;
          }

        })).pipe();
  }

}
